type Opts = string[] | number[]

type Response = {
  isValid: boolean,
  message: string,
}

type Message =
  | string
  | string[]
  | {
      [key: string]: string,
    }

export default (validationArray: Opts, hydrate, message: Message = 'Please change') =>
  (value): ?Response => {
    const hydratedValue = hydrate(value)
    const index = validationArray.indexOf(hydratedValue)
    if (index !== -1) {
      return {
        isValid: false,
        message: Array.isArray(message)
          ? message[index]
          : typeof message === 'object'
          ? message[validationArray[index]]
          : message,
      }
    }
  }
